<style lang="css" scoped>

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}

.modal-container {
    width: 800px;
    margin: 40px auto 0;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.form-label > .form-control {
    margin-top: 0.5em;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.ipoe_sub_search {
    padding-left: 15px;
}

</style>

<template>
    <div name="modal" v-show="value">
        <div class="modal-mask" @click="cancel">
            <div class="modal-container" @click.stop>
                <v-data-table
                    :headers="headers"
                    :items="filtered_items"
                    :search="search"
                    :single-select=true
                    item-key="id"
                    sort-by="id"
                    class="elevation-1"
                    show-select
                    return-object
                    @dblclick:row="on_dbl_click"
                    v-model="selected_items"
                >
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title>Select IPoE subscriber</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <div class="ipoe_sub_search">
                            <v-text-field
                                v-model="svid"
                                label="SVID">
                            </v-text-field>
                            <v-text-field
                                v-model="cvid"
                                label="CVID">
                            </v-text-field>
                            <v-btn @click="lookup_subsc()">Lookup subscribers</v-btn>
                        </div>
                        <v-toolbar flat>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Filter"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-toolbar>
                    </template>
                    <template v-slot:no-data>
                    </template>
                </v-data-table>
            
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="select">Select</v-btn>
            </div>
        </div>
    </div>
</template>
  
<script>

import api_client from '../services/api.js';

export default {
    name: 'ipoe_sub_box',
    data: () => ({
        filter_prms: {},
        svid: '',
        cvid: '',

        selected_items: [],
        search: '',
        items: [],
        filtered_items: [],
        headers: [
            { text: 'VIF ID', value: 'vif_id', align: 'start' },
            { text: 'Username', value: 'username' },
            { text: 'Port', value: 'port_id' },
            { text: 'SVID', value: 'svid' },
            { text: 'CVID', value: 'cvid' },
            { text: 'MAC', value: 'mac' },
            { text: 'IP', value: 'ip' },
            { text: 'Session ID', value: 'sess_id' },
            { text: 'Circuit ID', value: 'subsc_id' },
            { text: 'Remote ID', value: 'remote_id' },      
            { text: 'Ingress Qdisc', value: 'ingress_car' },
            { text: 'Egress Qdisc', value: 'egress_car' },
            { text: 'RX pkts', value: 'rxp' },
            { text: 'TX pkts', value: 'txp' },
            { text: 'RX bytes', value: 'rxb' },
            { text: 'TX bytes', value: 'txb' },
            { text: 'PBR', value: 'pbr' },
            { text: 'L2 PBR', value: 'l2_pbr' },
            { text: 'TTL', value: 'ttl' },
            { text: 'Expire in', value: 'expire_in' },
            { text: 'Uptime', value: 'uptime', width: '300px' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
    }),

    created() {
    },

    props: {
        value: {
            required: true
        }
    },
    methods: {
        filter_items() {
            this.filter_prms['svid'] = this.svid.trim();
            this.filter_prms['cvid'] = this.cvid.trim();

            this.filtered_items = this.items.filter((i) => {
                if (this.filter_prms.svid != '' && i.svid != this.filter_prms.svid)
                    return false; 
                if (this.filter_prms.cvid != '' && i.cvid != this.filter_prms.cvid)
                    return false; 
                return true;
            });
        },

        lookup_subsc() {
            api_client.run_get_query('/ipoe/subsc')
            .then(response => {
                this.items = response.data;
                this.filter_items();
            })
            .catch(error => {
                console.log(error);
            });
        },

        on_dbl_click(event, data) {
		    this.$emit("selected", 
                    { 
                      id: data.item.vif_id,
                      username: data.item.username
                    }
            );
        },

        select() {
            if (typeof this.selected_items[0] != "undefined") {
                this.$emit("selected",
                    { 
                      id: this.selected_items[0].vif_id, 
                      username: this.selected_items[0].username
                    });
            }
        },

        cancel() {
            this.$emit("canceled");
        },
    }
};
</script>
